import styled from "@emotion/styled";
import { ReactNode } from "react";
import { useResizeDetector } from "react-resize-detector";

type ContentProps = {
  heightOffset?: number
}

const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  // Without an explicit offset, fill what the shell's header leaves: Mantine publishes its height, which
  // is no longer a fixed 60px now that the top bar carries a status strip.
  height: ${(props) => props.heightOffset != null
    ? `calc(100vh - ${props.heightOffset}px)`
    : "calc(100vh - var(--mantine-header-height, 60px))"};

  .sizer {
    flex-grow: 1;

    .sizer-clip {
      overflow: hidden;
      transform: translateZ(0);
      height: 100%;
    }
  }
`;

export const ResizeableContent = (props: {
  heightOffset?: number,
  children: ((size: { width?: number, height?: number }) => ReactNode | undefined) | ReactNode | undefined
}) => {
  const { heightOffset, children } = props;

  const { ref, width, height } = useResizeDetector();

  return (
    <Content heightOffset={heightOffset}>
      <div className="sizer">
        <div className="sizer-clip" ref={ref}>
          <div
            style={{
              position: "relative",
              width: width ?? 100,
              height: height ?? 100
            }}>
            {children instanceof Function ? children({ width, height }) : children }
          </div>
        </div>
      </div>
    </Content>
  );
};
